import { Component } from 'react'
// Components
import { Button, IconPlusAdd } from '@tracklib/kit'
import Email from 'components/profile/email'

// Types
import { Email as EmailType } from 'types'

import styles from './emailsform.css'

type Props = {
  emails: Array<EmailType>
  setPrimaryEmail: (email: string) => void
  addEmail: (email: string) => void
  deleteEmail: (email: string) => void
}

type State = {
  modalIsOpen: boolean
}

class EmailsForm extends Component<Props, State> {
  onRemove = (address: string) => {
    if (window.confirm('Are you sure you want to remove this email?')) {
      this.props.deleteEmail(address)
    }
  }

  onSetPrimary = (address: string) => {
    if (window.confirm(`Are you sure you want to make "${address}" your primary email address?`)) {
      this.props.setPrimaryEmail(address)
    }
  }

  onResendVerification = (address: string) => {
    this.props.addEmail(address)
  }

  render() {
    const { emails } = this.props
    return (
      <div>
        <div className={styles.wrapper}>
          <h2>Emails</h2>
          <p>Your primary email is used for all communications and notifications.</p>
          <ul className={styles.list}>
            {emails &&
              emails
                .sort((a, b) => a.email.localeCompare(b.email))
                .map(x => (
                  <Email
                    key={x.email}
                    email={x}
                    setPrimaryEmail={this.onSetPrimary}
                    resendVerification={this.onResendVerification}
                    remove={this.onRemove}
                  />
                ))}
          </ul>
          <Button modal to="addemail" variant="transparent" className={styles.addNew} datatesting="button_add_new_email">
            <IconPlusAdd /> Add new email
          </Button>
        </div>
        <footer className={styles.footer} />
      </div>
    )
  }
}

export default EmailsForm
